/**
 * Accedo OVP
 * API version: 1.2.0
 *
 * NOTE: This class was automatically generated by Swagger Code Generator. Do not edit it manually.
 */
'use strict';
var ApiClient = require('../ApiClient');
var Error = require('../model/Error');
var AuthSuccessResponse = require('../model/AuthSuccessResponse');
var TokenValidityResponse = require('../model/TokenValidityResponse');
  /**
   * Auth service.
   * @module api/AuthApi
   * @version 1.4.0
   */

  /**
   * Constructs a new AuthApi. 
   * @alias module:api/AuthApi
   * @class
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function() {

    this.apiClient = new ApiClient();

            

    /**
     * Authenticate user with username and password
     * @param {String} xUser 
     * @param {String} xPassword 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AuthSuccessResponse}
     */
    this.authenticate = function(xUser, xPassword) {

      var postBody = null;

      // verify the required parameter 'xUser' is set
      if (xUser == undefined || xUser == null) {
        throw "Missing the required parameter 'xUser' when calling authenticate";
      }

      // verify the required parameter 'xPassword' is set
      if (xPassword == undefined || xPassword == null) {
        throw "Missing the required parameter 'xPassword' when calling authenticate";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        'X-User': xUser,
        'X-Password': xPassword
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = AuthSuccessResponse;

      return this.apiClient.call(
        '/auth', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    };


    /**
     * Invalidate a user token
     * @param {String} token 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
    this.invalidateToken = function(token) {

      var postBody = null;

      // verify the required parameter 'token' is set
      if (token == undefined || token == null) {
        throw "Missing the required parameter 'token' when calling invalidateToken";
      }


      var pathParams = {
        'token': token
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.call(
        '/auth/{token}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    };


    /**
     * Check if the user token is still valid
     * @param {String} token 
     * @param {String} userId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TokenValidityResponse}
     */
    this.validateToken = function(token, userId) {

      var postBody = null;

      // verify the required parameter 'token' is set
      if (token == undefined || token == null) {
        throw "Missing the required parameter 'token' when calling validateToken";
      }

      // verify the required parameter 'userId' is set
      if (userId == undefined || userId == null) {
        throw "Missing the required parameter 'userId' when calling validateToken";
      }


      var pathParams = {
        'token': token
      };
      var queryParams = {
      };
      var headerParams = {
        'userId': userId
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = TokenValidityResponse;

      return this.apiClient.call(
        '/auth/{token}/valid', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType
      );
    };
  };

module.exports = exports;
